// extracted by mini-css-extract-plugin
export default {"strip":"rcmUN2","root":"ib4HtG","separatorHorizontal":"hkxGj8","logo":"LZZxxp","rightReserved":"JqCYjn"};